var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.canOp)?_c('DropdownItem',{attrs:{"name":_vm.name},nativeOn:{"click":function($event){return _vm.clickBtn.apply(null, arguments)}}},[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }